import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

  addLoader(event) {
    var eventOs = window.navigator.platform.toLocaleLowerCase()
    if (eventOs.includes('mac') && event.metaKey) {
      return
    } else if (event.ctrlKey) {
      return
    }
    this.showSpinner(event)
  }

  addUngroupedLoader(event) {
    var organizationId = this.element.dataset['organizationId']
    var loader = document.querySelector(`#ungrouped_loader_${organizationId}`)
    loader.classList.remove('hidden')
  }

  showSpinner(event) {
    var target = event.currentTarget
    if (target.dataset.spinner) {
      target.innerHTML = '<span><i data-lucide="loader-circle" class="w-4 h-4 inline animate-spin"></i></span>&nbsp;' + target.dataset.spinnerValue
      if (window.lucide) window.lucide.createIcons()
      target.setAttribute('disabled', true)
    }
  }

  toggle(event) {
    var variants = this.element.querySelectorAll('[data-id="report_variant"]')
    variants.forEach((variant) => {
      if (variant.classList.contains('bg-indigo-200')) {
        variant.dataset['status'] = 'old-active'
      } else {
        variant.dataset['status'] = ''
      }
      variant.classList.remove("bg-indigo-200", "text-indigo-600");
      variant.classList.add("text-gray-600")
    })
    event.currentTarget.classList.add("bg-indigo-200", "text-indigo-600")
    event.currentTarget.dataset['status'] = 'new-active'

    document.addEventListener("turbo:before-frame-render", function () {
      document.querySelectorAll('[data-id="report_variant"]').forEach((variant) => {
        variant.classList.add("text-gray-600")
        if (variant.dataset['status'] == 'old-active') {
          variant.classList.add("font-semibold", "bg-indigo-600", "text-white");
        } else if (variant.dataset['status'] == 'new-active') {
          variant.classList.remove("font-semibold", "bg-indigo-600", "text-white");
        }

      })
    })
  }


}
